import { Component, INJECTOR, Input, input } from '@angular/core';

export enum ButtonType {
  primary,
  secondary,
  tertiary,
  disabled
}

@Component({
    selector: 'app-button',
    templateUrl: './app-button.component.html',
    styleUrl: './app-button.component.scss',
    standalone: false
})
export class AppButtonComponent {

  @Input() text!: string;
  @Input() danger = false;
  @Input() buttonStyle!: keyof typeof ButtonType;
  @Input() disabled = false;
  @Input() icon!: string;
  @Input() type: 'button'|'submit' = 'button';
  @Input() callback!: () => void; //use this if a button can be disabled, as css pointer events are local only and will not bubble up to parent.

  handleClick() {
    if (this.callback) {
      this.callback();
    }
  }
}
